import classNames from 'classnames';
import useSessionProvider from 'providers/SessionProvider';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import StarRatings from 'react-star-ratings';

const StartRatingQuestion = ({ onChange, answer, question_id, disabled, ...props }) => {
    const [rating, setRating] = useState(0);
    const { i18n } = useTranslation();
    const { survey } = useSessionProvider();
    const [key, setKey] = useState(Math.random());
    const { negativeText, useIcon, positiveText, iconNegative, iconPositive, numOfStars, withNA } = props;
    const handleOnChange = (value) => {
        if (value === 'N/A') {
            setRating(0);
        } else {
            setRating(value);
        }
        if (onChange) {
            onChange({ label: value.toString(), value: value.toString() });
        }
    };

    useEffect(() => {
        if (answer && answer !== 'N/A') {
            setRating(answer);
        } else {
            setRating(0);
        }

        setKey(Math.random());
    }, [answer]);

    return (
        <>
            <div className={'main-star' + (numOfStars === 10 ? ' with--tenstar' : '')}>
                <div>
                    <StarRatings
                        key={key}
                        starRatedColor={survey?.customTheme ? survey?.theme?.starRatingColor || '#101013' : '#101013'}
                        starHoverColor={survey?.customTheme ? survey?.theme?.starRatingColor || '#101013' : '#101013'}
                        starDimension={'25px'}
                        starSpacing="2px"
                        numberOfStars={numOfStars}
                        rating={rating}
                        changeRating={disabled ? null : handleOnChange}
                        svgIconPath={
                            'M17.68,1.54,21.51,9.3l8.56,1.25a1.88,1.88,0,0,1,1,3.2l-6.2,6,1.47,8.53a1.87,1.87,0,0,1-2.72,2l-7.66-4-7.66,4a1.87,1.87,0,0,1-2.72-2l1.47-8.53-6.2-6a1.88,1.88,0,0,1,1-3.2L10.49,9.3l3.83-7.76A1.87,1.87,0,0,1,17.68,1.54Z'
                        }
                        svgIconViewBox={'0 0 32 31'}
                        {...props}
                    />
                </div>

                {useIcon && (
                    <div className="star-legend">
                        <div className="negative">
                            {!useIcon && <span>{negativeText[i18n.language]}</span>}
                            {useIcon && <i className={iconNegative} />}
                        </div>
                        <div className="positive">
                            {!useIcon && <span>{positiveText[i18n.language]}</span>}
                            {useIcon && <i className={iconPositive} />}
                        </div>
                    </div>
                )}
                {!useIcon && (
                    <div className="star-legend-text">
                        <div className="negative">
                            {!useIcon && <span>{negativeText[i18n.language]}</span>}
                            {useIcon && <i className={iconNegative} />}
                        </div>
                        <div className="positive">
                            {!useIcon && <span>{positiveText[i18n.language]}</span>}
                            {useIcon && <i className={iconPositive} />}
                        </div>
                    </div>
                )}
            </div>
            {withNA && (
                <div className="not-applicapable-star">
                    {
                        <button
                            onClick={() => {
                                handleOnChange('N/A');
                            }}
                            disabled={disabled}
                            className={classNames('btn-applicapable', {
                                'with--na': withNA,
                                active: answer === 'N/A'
                            })}>
                            N/A
                        </button>
                    }
                </div>
            )}
        </>
    );
};

export default StartRatingQuestion;
